import { Home, X } from "lucide-react";
import { propertyDisplayLabel } from "@/lib/propertyDisplay";
import type { PropertySummary } from "@/types/entities";

interface Props {
  property: PropertySummary;
  onRemove?: () => void;
}

export function DiaryPropertyCard({ property, onRemove }: Props) {
  return (
    <li className="text-sm text-bridge-fg bg-white p-4 rounded-lg border border-bridge-border/40 shadow-sm list-none">
      <div className="flex items-start gap-3">
        <Home className="text-bridge-accent mt-0.5 shrink-0" size={16} />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div className="font-semibold text-base">{propertyDisplayLabel(property)}</div>
            {onRemove && (
              <button
                type="button"
                onClick={onRemove}
                className="shrink-0 p-1 text-bridge-muted hover:text-bridge-fg rounded"
                aria-label="Remove property"
              >
                <X size={14} />
              </button>
            )}
          </div>
          <div className="text-xs text-bridge-muted mt-1 uppercase tracking-wider font-bold">
            {property.propertyType || "—"} • {property.availabilityStatus || "—"}
          </div>
          <div className="flex flex-wrap gap-4 mt-3 text-xs text-bridge-fg/80 bg-bridge-surface px-3 py-2 rounded-md">
            <span>
              <span className="font-bold">{property.bedrooms ?? 0}</span> Bed
            </span>
            <span>
              <span className="font-bold">{property.bathrooms ?? 0}</span> Bath
            </span>
            <span className="font-bold text-bridge-accent">
              {property.currency}
              {property.price?.toLocaleString() ?? "—"}
            </span>
          </div>
        </div>
      </div>
    </li>
  );
}
